import ThemeToggler from "./ThemeToggler";
import { formatNumDecimalPoint } from "../helpers";
export default function Header({
  themes,
  themeToggler,
  activeId,
  difficulty,
  setDifficulty,
  difficultyLevels,
  setTime,
}) {
  const theme = themes.find((theme) => theme.id === activeId);
  /*****/
  const difficultyLevelClasses = [
    "cursor-pointer",
    "font-bold",
    "font-mono",
    "text-sm",
    "hover:opacity-75",
    "transition-opacity",
    "duration-150",
    "ease-in-out",
  ];
  return (
    <header className="flex justify-center md:justify-between gap-5 lg:gap-0 flex-wrap md:flex-nowrap items-center px-11 md:px-0 py-9">
      <h1 className={`font-mono text-3xl ${theme.textPrimary}`}>WordRunner</h1>
      <ThemeToggler
        themeToggler={themeToggler}
        themes={themes}
        activeId={activeId}
      />
      <div className="flex gap-3">
        {difficultyLevels.map((level, index) => (
          <small
            key={index}
            onClick={() => {
              setDifficulty(level);
              setTime(formatNumDecimalPoint(level.limit, 2));
            }}
            className={`${difficultyLevelClasses.join(" ")} ${
              difficulty.level === level.level ? level.color : "text-gray-400"
            }`}
          >
            {level.level}
          </small>
        ))}
      </div>
    </header>
  );
}
